import { render, staticRenderFns } from "./OrderTask.vue?vue&type=template&id=2d7025c1"
import script from "./OrderTask.vue?vue&type=script&lang=js"
export * from "./OrderTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports